export default {
  signupType: (state) => state.signupType,
  infos: (state) => state.infos,
  infoLoading: (state) => state.infoLoading,
};
